import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { normalizeLanguage } from '../../helpers/intl';
import prepareResponseFailure from '../../helpers/prepareResponseFailure';
import { buildUrl } from '../../helpers/url';
import { ApiRequestDescriptor } from '../../services/apiRequest.types';
import { executeQuery } from '../../services/executeQuery';

const ENDPOINT = `${APIConfiguration.workflow}files/${COMMON_QUERY_PARAMS.FILE_ID}/states`;

export interface FileStateHistoryModuleSummary {
  id?: string;
  definitionId?: string;
  wave: number;
  parameters?: {
    [key: string]: string;
  };
  referencedModuleType?: string;
}

export interface StateSummary {
  name?: string;
  shortLabel?: string;
  label?: string;
}

export interface FileStateHistorySummary {
  fileId: string;
  module: FileStateHistoryModuleSummary;
  stateDate: Date;
  state: StateSummary;
  comment?: string;
  toCustomerComment?: string;
  duration?: Date;
  responsible: {
    userId: string;
    fullname?: string;
  };
}

export interface GetFileStatesQueryPayload {
  fileId: string;
  language?: string;
}

export type GetFileStatesQuery = (
  payload: GetFileStatesQueryPayload,
) => Promise<
  BackResponse<FileStateHistorySummary[] | undefined> | BackResponseFailure
>;

export const getFileStatesRequest = ({
  fileId,
  language,
}: GetFileStatesQueryPayload): ApiRequestDescriptor => ({
  url: buildUrl(ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId), {
    language: language ? normalizeLanguage(language) : undefined,
  }),
  config: { method: SUPPORTED_METHODS.GET },
});

export const getFileStatesQuery: GetFileStatesQuery = async (payload) => {
  try {
    return await executeQuery<
      BackResponse<FileStateHistorySummary[] | undefined>
    >(getFileStatesRequest(payload));
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
